import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useState } from "react";
import PutHooks from "../../../Api/PutHook";
import { useForm } from "react-hook-form";
import AlertComponent from "../../../Components/AlertComponent";

const WithdrawApprovalForm = ({ data, onClose, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [approval, setApproval] = useState("");

  const [approvalLoading, , approvalRequest] = PutHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const requestApproval = async () => {
    try {
      let formData = {
        request_id: data?.id,
        entity_id: data?.entity_id,
        amount: data?.amount,
        status: approval,
      };

      const approvalResponse = await approvalRequest({
        url: "pool_fund_request",
        body: formData,
      });

      if (
        approvalResponse &&
        approvalResponse.status === 200 &&
        approvalResponse.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: approvalResponse.data.StatusMessage,
        });

        onClose();
        onSuccess();
      } else {
        const errorMessage =
          approvalResponse?.data?.StatusMessage ??
          approvalResponse?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };
  return (
    <form onSubmit={handleSubmit(requestApproval)}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <FormControl
        fullWidth
        sx={{
          my: "20px",
        }}
      >
        <InputLabel id="status">Status</InputLabel>
        <Select
          labelId="status"
          id="status"
          defaultValue=""
          value={approval}
          label="Status"
          onChange={(e) => setApproval(e.target.value)}
          required
        >
          <MenuItem value="ACCEPTED">Accept </MenuItem>
          <MenuItem value="DECLINED">Decline </MenuItem>
        </Select>
      </FormControl>

      <Box
        sx={{
          pt: "40px",
          gap: 2,
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button type="reset" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          type="submit"
          loading={approvalLoading}
        >
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default WithdrawApprovalForm;
